import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

export const SpamPurge = ({ c, onDone }) => {
  const [open, setOpen] = useState(false); const [block, setBlock] = useState(false); const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.delete(`/shop/members/${c.member_id}`, { params: { block } });
      toast.success(`Dihapus: ${data.quotations} quotation, ${data.files} file, ${data.orders} pesanan belum bayar${data.blocked ? " · email diblokir" : ""}`);
      setOpen(false); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" title="Hapus member spam" data-testid={`spam-purge-${c.id}`} onClick={() => setOpen(true)} className="text-slate-400 hover:text-rose-600 mr-3"><ShieldAlert className="w-4 h-4" /></button>
      {open && <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={() => setOpen(false)} data-testid="spam-purge-modal">
        <div className="bg-white rounded-2xl p-5 max-w-sm w-full text-left whitespace-normal" onClick={(e) => e.stopPropagation()}>
          <b>Hapus member spam?</b>
          <p className="text-sm text-slate-600 mt-1">{c.name} · {c.email}</p>
          <p className="text-xs text-slate-500 mt-2">Akun, quotation & file 3D, keranjang, pesanan yang belum dibayar, dan data customer-nya akan dihapus. Pesanan yang sudah dibayar tetap disimpan untuk keuangan.</p>
          <div className="mt-3 space-y-2 text-sm">
            <label className="flex gap-2 items-start"><input type="radio" name="spm" checked={!block} onChange={() => setBlock(false)} data-testid="spam-opt-delete" className="mt-1" /> Hapus data saja <span className="text-xs text-slate-400">(masih bisa log in lagi)</span></label>
            <label className="flex gap-2 items-start"><input type="radio" name="spm" checked={block} onChange={() => setBlock(true)} data-testid="spam-opt-block" className="mt-1" /> Hapus data + blokir email <span className="text-xs text-slate-400">(tidak bisa log in lagi)</span></label>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button type="button" onClick={() => setOpen(false)} className="px-3 py-2 rounded-lg border border-slate-300 text-sm" data-testid="spam-cancel">Batal</button>
            <button type="button" disabled={busy} onClick={go} className="px-3 py-2 rounded-lg bg-rose-600 text-white text-sm disabled:opacity-50" data-testid="spam-confirm">Hapus</button>
          </div>
        </div>
      </div>}
    </>
  );
};
